module.exports = __webpack_public_path__ + "img/58.c30858c0.jpg";